<button mat-mini-fab matTooltip="Precisa de ajuda? Clique aqui para abrir um chamado." matTooltipPosition="left"
    class="help-button" (click)="openHelpDesk()">
    <img src="../../../assets/images/help_desk_icon.svg"
        alt="Help Desk">
</button>